module.exports = __webpack_public_path__ + "teg/media/nithin.654fb53f.png";